import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import products from "../data/product";
import { Link } from "react-router-dom";
import slugify from "../utils/slugify";

const ProductDetails = () => {
  // scroll animation (one time for home page)
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  const { slug } = useParams();

  const productIndex = products.findIndex(
    (item) => slugify(item.productName) === slug
  );

  const product = products[productIndex];

  if (!product) {
    return <h2 style={{ color: "#fff", textAlign: "center" }}>Product Not Found</h2>;
  }

  // Next 4 products
  const relatedProducts = products.slice(
    productIndex + 1,
    productIndex + 5
  );

  return (
    <section className="section product-details-section">
      <Container>

        <Row className="align-items-center mb-5 fade-up">
          <Col lg={6}>
            <img
              src={product.image}
              alt={product.productName}
              className="product-details-image"
            />
          </Col>

          <Col lg={6} className="product-details-content">
            <h2>{product.productName}</h2>

            <p>
              <strong>Technical Name:</strong> {product.technicalName}
            </p>
            <p>
              <strong>Category:</strong> {product.category}
            </p>
            <p>
              <strong>Formulation:</strong> {product.formulation}
            </p>
            <p>
              <strong>Pack Size:</strong> {product.packSize}
            </p>

            <p>{product.description}</p>
          </Col>
        </Row>

        {/* RELATED PRODUCTS */}
        <div className="section-title fade-up">
          <h2>Related Products</h2>
          <p>Explore more trusted agricultural solutions</p>
        </div>

        <Row>
          {relatedProducts.map((item) => (
            <Col lg={3} md={6} className="mb-4" key={item.id}>
              <div className="product-card">

                <img
                  src={item.image}
                  alt={item.productName}
                  style={{ width: "100%", height: "250px", objectFit: "cover" }}
                />

                <div className="product-overlay">
                  <Link
                    to={`/product/${slugify(item.productName)}`}
                    className="product-btn"
                  >
                    View Details
                  </Link>
                </div>

              </div>
            </Col>
          ))}
 
        </Row>

      </Container>
    </section>
  );
};

export default ProductDetails;
